var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _path19, _path20, _path21, _circle, _circle2, _circle3, _circle4, _path22, _path23, _path24, _circle5, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 348,
    viewBox: "0 0 530 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 244.659,
    width: 529.209,
    height: 102.385,
    fill: "url(#paint0_radial_1_6155)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.67 220.185V106.611C237.67 106.611 237.36 86.1125 258.388 74.1198C262.112 71.996 266.398 70.7541 270.83 70.515C275.262 70.2759 279.69 71.0476 283.682 72.7552L375.548 112.096C375.548 112.096 367.197 105.928 353.869 115.329C340.54 124.729 339.326 137.798 338.463 152.686V243.868V260.545C338.463 260.545 336.288 274.918 326.516 283.287C316.744 291.657 312.548 293.203 312.548 293.203C312.548 293.203 302.673 297.266 296.596 295.477C290.518 293.688 273.064 264.305 273.064 264.305L241.279 241.563L237.67 220.185Z",
    fill: "#CCDBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 246.505C311.378 246.505 325.038 247.066 330.468 256.129C335.899 265.191 326.619 280.324 326.619 280.324C324.48 284.258 317.762 290.068 313.571 292.531C309.379 294.995 304.488 296.457 299.406 296.766C278.426 289.862 289.699 265.582 289.699 265.582L298.371 254.309L311.378 246.505Z",
    fill: "#C8D0F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.378 246.505C311.378 246.505 325.038 247.066 330.468 256.129C335.899 265.191 326.12 275.121 326.12 275.121C323.98 279.055 321.64 280.462 317.448 282.925C313.256 285.389 304.441 283.792 304.441 283.792L287.098 272.519L289.699 265.582L298.371 254.309L311.378 246.505Z",
    fill: "#ABC2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.236 260.379C331.905 269.2 326.155 276.884 321.784 280.324C313.694 286.69 304.021 283.786 304.021 283.786L287.965 273.03",
    stroke: "#9EB6F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.994 137.243L389.422 161.523C389.422 161.523 390.915 128.106 385.086 119.9C372.079 107.76 364.484 111.919 358.204 112.963C354.016 113.728 343.463 123.369 339.994 137.243Z",
    fill: "#7EA0F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.959 208.805L322.651 247.372C322.651 247.372 299.922 243.786 288.832 268.184C280.161 287.261 297.477 297.221 297.477 297.221L192.798 247.466C192.798 247.466 181.643 236.966 192.798 217.022C203.954 197.077 225.959 208.805 225.959 208.805Z",
    fill: "#DCE6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M306.175 296.17C306.175 296.17 327.386 290.491 331.323 268.184C333.924 253.442 320.917 241.302 304.441 249.973C291.853 256.599 280.863 275.195 289.699 290.729C298.535 306.264 338.26 291.597 337.967 253.442V146.413C337.967 146.413 337.967 129.16 351.013 117.764C364.059 106.367 379.233 110.352 386.322 122.312C388.95 126.747 389.665 133.42 389.44 138.609V160.656",
    stroke: "#9EB6F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.523 198.645L265.595 204.633M301.809 222.599L295.773 219.605L292.755 218.108M271.63 207.628L277.666 210.622L289.737 216.61",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.897 170.198H237.678V180.503V183.494L245.989 181.5L255.297 192.137L267.264 189.478L277.236 199.451L287.874 198.121L295.852 204.769H305.159L316.461 212.747L309.813 201.445L300.505 198.786L290.607 187.483L278.196 186.154L271.991 177.179H256.479L252.342 170.198H238.897Z",
    fill: "#7EA0F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M251.081 170.969H237.678V181.234L248.648 178.841L257.291 190.143L269.923 187.483L279.231 197.722L289.868 196.126L297.846 203.44L306.489 204.104L315.797 211.418L308.483 202.11L299.841 199.451L290.533 188.893L278.566 187.483L271.917 178.229H256.626L251.081 170.969Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M253.523 152L321.49 186.077",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.523 139.473L262.019 143.733L266.267 145.863M321.49 173.55L312.994 169.291L308.747 167.161M287.507 156.512L304.499 165.031",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.523 126.931L262.019 131.193L266.267 133.324M321.49 161.024L312.994 156.763M270.515 135.455L287.507 143.978L304.499 152.501L308.747 154.632",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M253.523 114.405L257.771 116.535M321.49 148.482L304.499 139.963L296.003 135.703M287.507 131.444L279.011 127.184L274.763 125.054M270.515 122.924L266.267 120.795L262.019 118.665",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M272.583 151.919V160.907L275.851 154.487L272.583 151.919Z",
    fill: "#5682F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.928 187.324C292.884 187.324 272.582 175.375 272.582 160.634C272.582 145.894 292.884 131.221 317.928 131.221C342.972 131.221 363.274 145.894 363.274 160.634C363.274 175.375 342.972 187.324 317.928 187.324ZM317.928 179.154C298.6 179.154 282.932 170.619 282.932 160.09C282.932 149.561 298.6 141.025 317.928 141.025C337.256 141.025 352.925 149.561 352.925 160.09C352.925 170.619 337.256 179.154 317.928 179.154Z",
    fill: "#5682F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M344.346 182.422V174.388H356.601L381.615 185.489V192.137C381.615 194.316 380.432 195.495 377.572 197.401C375.284 198.926 371.898 198.037 370.491 197.401L344.346 182.422Z",
    fill: "#8AACFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M363.274 152.192V160.771L359.87 154.643L363.274 152.192Z",
    fill: "#5682F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.8,
    cx: 317.126,
    cy: 156.236,
    rx: 35.2363,
    ry: 19.2802,
    fill: "url(#paint1_linear_1_6155)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M281.111 153.713L280.56 154.907C280.56 154.907 280.725 154.462 281.111 153.713L288.538 137.621L317.126 129.643L343.72 133.632L355.687 145.599L353.027 158.231C353.027 158.231 354.363 136.956 315.132 136.956C291.603 136.956 283.18 149.701 281.111 153.713Z",
    fill: "#2E31BE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.928 179.154C292.884 179.154 272.582 167.326 272.582 152.736C272.582 138.146 292.884 126.319 317.928 126.319C342.972 126.319 363.274 138.146 363.274 152.736C363.274 167.326 342.972 179.154 317.928 179.154ZM317.928 173.162C298.549 173.162 282.839 164.017 282.839 152.736C282.839 141.455 298.549 132.31 317.928 132.31C337.307 132.31 353.017 141.455 353.017 152.736C353.017 164.017 337.307 173.162 317.928 173.162Z",
    fill: "#E8EEFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380.159 183.375L354.15 168.124L343.529 173.843C351.563 178.518 368.176 188.196 370.355 189.503C372.534 190.81 374.803 190.774 375.666 190.593C376.71 190.366 379.206 189.421 380.84 187.461C382.544 185.416 381.067 183.92 380.159 183.375Z",
    fill: "#E8EEFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 204.769,
    cy: 130.308,
    r: 3.98901,
    fill: "#2E31BE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 427.489,
    cy: 194.797,
    r: 3.32418,
    fill: "#EAF0FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.775,
    cy: 3.32416,
    r: 3.32418,
    fill: "#EAF0FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.824,
    cy: 187.483,
    r: 3.23901,
    stroke: "#B5CAFD",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M233.837 170.335L232.426 168.306L231.721 167.292M228.196 162.22L229.606 164.249",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M231.269 175.248L226.33 175.101L225.095 175.064M221.39 174.953L222.625 174.99",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M233.972 180.835L230.727 184.561M227.481 188.288L229.104 186.425",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.335,
    cy: 55.1813,
    r: 6.56319,
    stroke: "#B5CAFD",
    strokeWidth: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.278 89.0879V97.7308",
    stroke: "#B5CAFD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.599 93.4093L136.956 93.4093",
    stroke: "#B5CAFD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M375.766 215.122L371.016 225.835",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M378.748 222.854L368.035 218.104",
    stroke: "#2E31BE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_6155",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.286 218.731) rotate(89.2595) scale(55.2739 285.701)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_6155",
    x1: 317.126,
    y1: 136.956,
    x2: 317.126,
    y2: 175.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.f6180c70a2fa553ee8ed90713dab1a00.svg";
export { ForwardRef as ReactComponent };